<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>使用说明</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="bb_instructions">
      <div class="bb_instructions_item">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item title="1.什么是代金券?" name="1">
            a.斐燃送给所有开卡会员本人使用的现金抵用券；
            <br />
            b.可用于抵扣本人年费续费（每次限使用1张）；
            <br />
            c.可用于抵扣本人预约费用（每次限使用1张）。
          </van-collapse-item>
          <van-collapse-item title="2.什么是邀约券?" name="2">
            a.  斐燃送给所有开卡会员，转赠给非会员使用的开卡现金抵用券；
            <br />
            b.  仅限非会员用于开通会员使用（每次限使用1张）。
          </van-collapse-item>
          <van-collapse-item title="3.代金券的使用条件?" name="3">
            a.仅限会员本人使用；
            <br />
            b.仅限会员身份有效期内使用，一旦会员过期代金券即作废；
            <br />
            c.可用于会员卡年费续费（每次限使用1张）；
            <br />
            d.可用于预约酒店健身服务（每次限制使用1张）。
          </van-collapse-item>
          <van-collapse-item title="4.邀约券的使用条件?" name="4">
            a.仅限非会员用于开通会员使用（每次限使用1张）；
            <br />
            b.非会员包括：从未开过卡的新会员和会员已过期的用户（没有接受上限）。
          </van-collapse-item>
          <van-collapse-item title="5.如何获得邀约券?" name="5">
            a.开通斐燃会员就送啊；
            <br />
            b.非会员快去问老会员要。
          </van-collapse-item>
          <van-collapse-item title="6.如何获得代金券?" name="6">
            a.参加开卡礼包活动开通斐燃会员赠送代金券。
          </van-collapse-item>
          <van-collapse-item title="7.代金券和邀约券是否可同时使用?" name="7">
            a.不可以同时使用。
          </van-collapse-item>
          <van-collapse-item title="8.如何赠送好友邀约券?" name="8">
            a.  通过你的客户端，从[我的优惠券]—[邀约券]—赠送好友
          </van-collapse-item>
          <van-collapse-item title="9.代金券可以找零、兑换吗?" name="9">
            a.  不可以。
          </van-collapse-item>
          <van-collapse-item title="10.代金券使用后还可以退还吗?" name="10">
            a.  预约订单退订后，如有使用代金券，代金券将退还；
            <br />
            b.  用于开通会员卡的代金券，使用即作废，不可退还。
          </van-collapse-item>
          <van-collapse-item title="11.赠送邀约券是否有次数限制?" name="11">
            a.老会员赠送给非会员使用；（不限赠送人数及张数）；
            <br />
            b.非会员包括：从未开过卡的新会员和会员已过期的用户（没有接受上限）。
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName:'1'
      }
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .bb_instructions{
    width: 100%;
    height: auto;
    padding: 40*@vm_base 32*@vm_base;
    .bb_instructions_item{
      background: #FFFFFF;
      padding: 40*@vm_base;
      .van-cell{
        padding: 10px 0;
        color: #666666;
        font-size: 32*@vm_base;
      }
      .van-collapse-item__wrapper{
        background:rgba(251,251,251,1);
      }
      .van-collapse-item__content{
        background: none;
        color: #666666;
        padding: 20*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 400;
      }
      .van-cell:not(:last-child)::after{
        border-bottom: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/coupon/couponrule.vue